import * as React from 'react';
import { useTranslations } from 'next-intl';
import { FunnelSimpleIcon, XCircleIcon } from '@phosphor-icons/react';
import { styled } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import { TextField, IconButton } from '@unity/cloud-ui';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

interface SidebarFilterProps {
  searchValue?: string;
  onSearch: (value: string | null) => void;
}

export const SidebarFilter = (props: SidebarFilterProps) => {
  const { onSearch, searchValue } = props;
  const t = useTranslations();
  const [value, setValue] = React.useState(searchValue || '');
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;
    onSearch(value);
    setValue(value);
  };

  const handleClear = () => {
    onSearch(null);
    setValue('');
    inputRef.current?.focus();
  };

  return (
    <StyledTextField
      inputRef={inputRef}
      id="sidebar-filter"
      value={value}
      onChange={handleOnChange}
      placeholder={t('sidebar:filter:placeholder')}
      slotProps={{
        input: {
          'aria-label': t('sidebar:filter:aria-label'),
          startAdornment: (
            <InputAdornment position="start">
              <FunnelSimpleIcon size={16} aria-hidden="true" focusable="false" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" sx={{ width: '24px' }}>
              {!!value && (
                <IconButton size="small" aria-label={t('sidebar:filter:clear')} onClick={handleClear}>
                  <XCircleIcon weight="fill" size={16} aria-hidden="true" focusable="false" />
                </IconButton>
              )}
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
